export const ConfirmationReceiptConfig = {
  download: '/snapshot/receiptPDF/dataflow/{:dataflowId}/dataProvider/{:dataProviderId}'
};
